
<div class="detalle__movimiento">
    <div class="detalle__title-2">
        <h2>Horario de Atención de Estaciones</h2>
        <div class="btn-group">
            <label>Buscar</label>
            <input type="text" [(ngModel)]="filter" placeholder="Ingrese búsqueda" [attr.disabled]="error ? true : loading ? true : null">
        </div>
    </div>
    <div class="movimientos movimientosComponent">
        <div  class="movimientos__items">
            <div>
                <h2>Nombre Estación</h2>
            </div>
            <div>
                <h2>Lunes a Viernes</h2>
            </div>
            <div>
                <h2>Sábado</h2>
            </div>
            <div>
                <h2>Domingo</h2>
            </div>
        </div>
        <div *ngIf="error" class="alert red"><p>{{ msjError }}</p></div>
        <ng-container *ngIf="(horario | filterHorarios:filter) as result">
            <div *ngIf="result.length === 0" class="alert red"><p>No se encontraron registros</p></div>

            <div  *ngFor="let data of result; let i = index" class="movimientos__items content">
                <div class="body">
                    <h2>Nombre Estación</h2>
                    <p>{{data.sDesLargo01}}</p>
                </div>
                <div class="body">
                    <h2>Lunes a Viernes</h2>
                    <p>{{data.sCodigo02}} - {{data.sCodigo03}} </p>
                </div>
                <div class="body">
                    <h2>Sábado</h2>
                    <p>{{data.sCodigo04}} - {{data.sCodigo05}}</p>
                </div>
                <div class="body">
                    <h2>Domingo</h2>
                    <p>{{data.sDesCorto04}} - {{data.sDesCorto05}}</p>
                </div>
            </div>
        </ng-container>
    </div>
</div>
